import { Injectable, inject } from '@angular/core';
import {PercentPipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ComparePercentageService {
  private percentPipe = inject(PercentPipe);


  build(
    value: number | undefined,
    compareValue: number | undefined,
    {
      digitsInfo = '1.2-2',
      noInitial,
    }: {
      digitsInfo?: string;
      noInitial?: boolean;
    } = {}
  ): string | undefined {
    let str: string | undefined;
    if (
      value !== undefined &&
      compareValue !== undefined
    ) {
      const compareAmount: number = value - compareValue;
      const initial: string = this.buildInitial(compareAmount);
      if (
        compareValue !== 0
      ) {
        const calculatedCompareValue: number = this.calculateCompareValue(
          compareAmount,
          compareValue,
          initial,
        );
        str = `${initial}${(this.percentPipe.transform(calculatedCompareValue / 100.0, digitsInfo))}`;
      } else {
        str = `${(initial ? initial : '-')}∞`;
      }
    }
    if (
      noInitial &&
      str &&
      (
        str.startsWith('-') ||
        str.startsWith('+')
      )
    ) {
      str = str.substring(1);
    }
    return str;
  }

  calculateCompareValue(
    compareAmount: number,
    compareValue: number,
    initial: string,
  ): number {
    let calculatedCompareValue: number = 100 * (compareAmount / compareValue);
    if (
      initial === '+' &&
      calculatedCompareValue < 0
    ) {
      calculatedCompareValue = -calculatedCompareValue;
    }
    return calculatedCompareValue;
  }

  buildInitial(
    compareAmount: number,
  ): string {
    let initial: string = '';
    if (
      compareAmount > 0
    ) {
      initial = '+';
    }
    return initial;
  }
}
